<template>
  <!-- CREATE Subscription -->
  <v-dialog
    v-model="addEditSubscriptionModal"
    persistent
    max-width="500px"
  >
    <v-card>
      <form @submit.prevent="submitForm()">
        <v-card-title style="padding-bottom: 0px">
          <v-flex
            xs11
            sm11
            md11
          ><span class="headline">{{ $t('addEditSubscription.addTitle') }}</span></v-flex>
          <v-flex
            xs1
            sm1
            md1
          >
            <v-btn
              flat
              @click="closeAddEditSubscriptionModal(), $validator.reset()"
              class="close"
            ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              md12
              class="px-2"
            >
              <v-text-field
                :label="$t('addEditSubscription.nameLabel') + '*'"
                v-model="addEditData.subscription_name"
                :error-messages="errors.collect('Subscription Name')"
                data-vv-name="Subscription Name"
                v-validate="'required'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click="closeAddEditSubscriptionModal(), $validator.reset()"
            outline
            color="normal"
          >{{ $t('common.cancel') }}</v-btn>
          <v-btn
            type="submit"
            style="height:auto" class="rtl-mr-2-5pct"
            outline
            color="success"
          >{{ $t('common.save') }}</v-btn>
        </v-card-actions>
      </form>

      <form
        id="login_success99"
        @submit.prevent="phoneLogin"
      >
        <input
          type="hidden"
          name="_token"
          value="QH65OXMU7MRnJg6UIS2LucakcxXX5LP88cFsEEwL"
        />
        <input
          id="csrf"
          type="hidden"
          name="csrf"
        />
        <input
          id="code"
          type="hidden"
          name="code"
        />
        <button
          type="submit"
          id="phone"
        ></button>
      </form>
    </v-card>
  </v-dialog>
  <!-- /CREATE Subscription -->
</template>

<script>

export default {
  props: [
    'addEditData',
    'addEditSubscriptionModal',
    'closeAddEditSubscriptionModal',
    'submitAddEditSubscription'
  ],

  data() {
    return {
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.submitAddEditSubscription()
        }
      })
    }
  }
}
</script>

<style scoped>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/addEditSubscription.vue